// extracted by mini-css-extract-plugin
module.exports = {"c-seo-text-title":"_025a50318d--c-seo-text-title--3xwGc","c-seo-text-col":"_025a50318d--c-seo-text-col--1c0Xk"};